const vatSettlement = [
    {
        name: "FA_13",
        value: 1
    },
    {
        name: "FA_VAT",
        value: 2
    },
    {
        name: "VAT_19_USTG",
        value: 3
    }
]

export default vatSettlement;